export default __webpack_public_path__ + "static/media/Plavas-Plus-ban.3fa2553a.jpg";